import { createContext, useContext, useEffect, useState } from "react";
import api from "../api";

const AuthCtx = createContext(null);

// Normalise a user object so downstream components can rely on `roles` being an array.
const normalise = (u) => {
  if (!u || typeof u !== "object") return u;
  const roles = Array.isArray(u.roles) && u.roles.length ? u.roles : (u.role ? [u.role] : []);
  return { ...u, roles, role: roles[0] || u.role };
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(normalise(r.data)))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("token", data.token);
    setUser(normalise(data));
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("token");
    setUser(false);
  };

  const hasRole = (...needed) => {
    if (!user || !user.roles) return false;
    if (user.roles.includes("admin")) return true;
    return needed.some((r) => user.roles.includes(r));
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, setUser, hasRole }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
